import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-3 items-start" }

import {defineAsyncComponent} from "vue"

export type ProjectAttribute = string


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectAttributes',
  props: {
    attributes: {}
  },
  setup(__props: any) {



function importComponent(attributeName: string) {
    return defineAsyncComponent(() => import(`./@attributes/${attributeName}Attribute.vue`))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributes, (attribute) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(importComponent(attribute)), { key: attribute }))
    }), 128))
  ]))
}
}

})